import { IDocument } from '../common';

export const CMS_PAGE_TITLES = {
  LANDING: 'LANDING',
  ABOUTUS: 'ABOUTUS',
  FAQ: 'FAQ',
  GETINTOUCH: 'GETINTOUCH',
  PRICING: 'PRICING',
  SITESETTING: 'SITESETTING',
} as const;

export type CMSPageTitleType = (typeof CMS_PAGE_TITLES)[keyof typeof CMS_PAGE_TITLES];

export type CmsPageDataSectionTypes = { [key: string]: string | string[] | undefined };

export interface CmsPageDataTypes {
  heroSection: CmsPageDataSectionTypes;
  featureSection: CmsPageDataSectionTypes;
  useCaseSection: CmsPageDataSectionTypes;
  testimonialSection: CmsPageDataSectionTypes;
  informationSection: CmsPageDataSectionTypes;
  subscriptionSection: CmsPageDataSectionTypes;
  addOnsSection: CmsPageDataSectionTypes;
  settingSection: CmsPageDataSectionTypes;
  termsSection: CmsPageDataSectionTypes;
  policySection: CmsPageDataSectionTypes;
  contactSection: CmsPageDataSectionTypes;
}

export interface ICmsContent extends IDocument {
  pageTitle: CMSPageTitleType;
  pageData: CmsPageDataTypes;
}
